
import {
    TEAMSSCREEN_LOAD,
    TEAMSSCREEN_UNLOAD,
    TEAMSSCREEN_SET,
} from '../../../../actionDefinitions';

import {
    fetchTeamsSummary,
    fetchTeamsHierarchy,
    _createNewTeam
} from '../../../../api/v3/AdminApi';

import {
    fetchDomainValues
} from '../../../../api/v3/DataApi';

export function loadTeamsScreen() {
    return dispatch => {
        dispatch(loadTeamsSummary());
        dispatch(loadTeamsHierarchy());
        dispatch(loadDomainValues());
    };
}

export function loadDomainValues() {
    return dispatch =>
        fetchDomainValues()
            .then(payload => dispatch({ type: TEAMSSCREEN_LOAD, payload: { domainValues: payload.result } }))
            .catch(payload => dispatch({ type: TEAMSSCREEN_LOAD, error: true, payload }))
}

export function loadTeamsSummary() {
    return dispatch =>
        fetchTeamsSummary()
            .then(payload => dispatch({ type: TEAMSSCREEN_LOAD, payload: { teamsSummary: payload.result } }))
            .catch(payload => dispatch({ type: TEAMSSCREEN_LOAD, error: true, payload }))
}

export function loadTeamsHierarchy() {
    return dispatch =>
        fetchTeamsHierarchy()
            .then(payload => dispatch({ type: TEAMSSCREEN_LOAD, payload: { teamsHierarchy: payload.result } }))
            .catch(payload => dispatch({ type: TEAMSSCREEN_LOAD, error: true, payload }))
}

export function createNewTeam(newTeam) {
    return dispatch =>
        _createNewTeam(newTeam)
            .then(payload => dispatch({ type: TEAMSSCREEN_LOAD, payload: { newlyAddedTeam: payload.result } }))
            .catch(payload => dispatch({ type: TEAMSSCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: TEAMSSCREEN_SET, updatedProps });
    }
}
